/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  CountRequestDto,
  CountResponseDto,
  GetPeopleParams,
  PlutoPerson
} from '../../model';





/**
 * Can be used for getting people count.
 * @summary Get people count in JSON
 */
export const countPeopleExtended = (
    countRequestDto: CountRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CountResponseDto>> => {
    
    
    return axios.default.post(
      `/api/v1.1/person/count/extended`,
      countRequestDto,options
    );
  }



export const getCountPeopleExtendedMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countPeopleExtended>>, TError,{data: CountRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof countPeopleExtended>>, TError,{data: CountRequestDto}, TContext> => {

const mutationKey = ['countPeopleExtended'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof countPeopleExtended>>, {data: CountRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  countPeopleExtended(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CountPeopleExtendedMutationResult = NonNullable<Awaited<ReturnType<typeof countPeopleExtended>>>
    export type CountPeopleExtendedMutationBody = CountRequestDto
    export type CountPeopleExtendedMutationError = AxiosError<unknown>

    /**
 * @summary Get people count in JSON
 */
export const useCountPeopleExtended = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countPeopleExtended>>, TError,{data: CountRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof countPeopleExtended>>,
        TError,
        {data: CountRequestDto},
        TContext
      > => {

      const mutationOptions = getCountPeopleExtendedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Can be used for listing people.
 * @summary Get people in JSON
 */
export const getPeople = (
    params: GetPeopleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlutoPerson[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/person`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetPeopleQueryKey = (params?: GetPeopleParams,) => {
    return [
    `/api/v1.1/person`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPeopleQueryOptions = <TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(params: GetPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPeopleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPeople>>> = ({ signal }) => getPeople(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof getPeople>>>
export type GetPeopleQueryError = AxiosError<unknown>


export function useGetPeople<TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(
 params: GetPeopleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPeople>>,
          TError,
          Awaited<ReturnType<typeof getPeople>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPeople<TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(
 params: GetPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPeople>>,
          TError,
          Awaited<ReturnType<typeof getPeople>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPeople<TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(
 params: GetPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get people in JSON
 */

export function useGetPeople<TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(
 params: GetPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPeopleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPeopleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(params: GetPeopleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPeopleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPeople>>> = ({ signal }) => getPeople(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPeopleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPeople>>>
export type GetPeopleSuspenseQueryError = AxiosError<unknown>


export function useGetPeopleSuspense<TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(
 params: GetPeopleParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPeopleSuspense<TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(
 params: GetPeopleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPeopleSuspense<TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(
 params: GetPeopleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get people in JSON
 */

export function useGetPeopleSuspense<TData = Awaited<ReturnType<typeof getPeople>>, TError = AxiosError<unknown>>(
 params: GetPeopleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPeople>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPeopleSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




